import React, { useEffect, useState } from "react";
import { CustomizedTreeItem } from "./CustomizedComponents";
import RenderLabelWithIcon from "./RenderLabelWithIcon";
import PropTypes from "prop-types";

const RecursiveTreeView = ({
	nodes,
	expandedNodes,
	addOrUpdateNodeLabel,
	addNewNode,
	selectedNodeForEdit,
	setSelectedNodeForEdit,
	onContextMenu,
	addToDeviceGroup,
	readOnly,
	getSelectedNodes,
	isForFacilitiesFloorPlan,
	getSelectedDevice,
	displayChevrons,
	getSelectedMenuItem,
	allowDeviceSelection
}) => {
	const [hoveredNodeId, setHoveredNodeId] = useState(null);
	const [selectedDevice, setSelectedDevice] = useState("");

	useEffect(() => {
		getSelectedDevice(selectedDevice);
	}, [selectedDevice]);

	return (
		<>
			{nodes.map((node) => (
				<div key={node?.id}>
					<CustomizedTreeItem
						nodeId={node?.id}
						label={
							<RenderLabelWithIcon
								node={node}
								isExpanded={expandedNodes.includes(node?.id)}
								hoveredNodeId={hoveredNodeId}
								setHoveredNodeId={setHoveredNodeId}
								selectedNodeForEdit={selectedNodeForEdit}
								setSelectedNodeForEdit={setSelectedNodeForEdit}
								addOrUpdateNodeLabel={addOrUpdateNodeLabel}
								addNewNode={addNewNode}
								readOnly={readOnly}
								addToDeviceGroup={addToDeviceGroup}
								getSelectedNodes={getSelectedNodes}
								isForFacilitiesFloorPlan={isForFacilitiesFloorPlan}
								setSelectedDevice={setSelectedDevice}
								selectedDevice={selectedDevice}
								getSelectedDevice={getSelectedDevice}
								displayChevrons={displayChevrons}
								getSelectedMenuItem={getSelectedMenuItem}
								allowDeviceSelection={allowDeviceSelection}
							/>
						}
						expandIcon={null}
						collapseIcon={null}
						sx={{
							outline: "none",
							border: "none",
							width: "100%",
							"& .MuiTreeItem-content": { width: "calc(100% - 40px) !important", minWidth: 0 },
							"& .MuiTreeItem-content.Mui-selected": {
								width: "calc(100% - 40px) !important"
							},
							"& .MuiTreeItem-label": {
								display: "block",
								width: "calc(100% - 40px) !important",
								minWidth: 0
							}
						}}
						onContextMenu={(e) => {
							e.preventDefault();
							e.stopPropagation();
							onContextMenu(e, node); // Pass the correct node
						}}
					>
						{node?.children?.length > 0 && (
							<RecursiveTreeView
								nodes={node?.children}
								expandedNodes={expandedNodes}
								addOrUpdateNodeLabel={addOrUpdateNodeLabel}
								addNewNode={addNewNode}
								selectedNodeForEdit={selectedNodeForEdit}
								setSelectedNodeForEdit={setSelectedNodeForEdit}
								onContextMenu={onContextMenu}
								addToDeviceGroup={addToDeviceGroup}
								readOnly={readOnly}
								getSelectedNodes={getSelectedNodes}
								isForFacilitiesFloorPlan={isForFacilitiesFloorPlan}
								getSelectedDevice={getSelectedDevice}
								displayChevrons={displayChevrons}
								getSelectedMenuItem={getSelectedMenuItem}
								allowDeviceSelection={allowDeviceSelection}
							/>
						)}
					</CustomizedTreeItem>
				</div>
			))}
		</>
	);
};

RecursiveTreeView.propTypes = {
	nodes: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			name: PropTypes.string,
			isDevice: PropTypes.bool,
			isGroup: PropTypes.bool,
			entityType: PropTypes.string,
			children: PropTypes.array
		})
	).isRequired,
	expandedNodes: PropTypes.arrayOf(PropTypes.string).isRequired,
	addOrUpdateNodeLabel: PropTypes.func,
	addNewNode: PropTypes.func,
	selectedNodeForEdit: PropTypes.string,
	setSelectedNodeForEdit: PropTypes.func,
	onContextMenu: PropTypes.func,
	addToDeviceGroup: PropTypes.bool,
	readOnly: PropTypes.bool,
	getSelectedNodes: PropTypes.func,
	isForFacilitiesFloorPlan: PropTypes.bool,
	getSelectedDevice: PropTypes.func,
	displayChevrons: PropTypes.bool
};

RecursiveTreeView.defaultProps = {
	nodes: [],
	expandedNodes: [],
	selectedNodeForEdit: null,
	addToDeviceGroup: false,
	readOnly: false,
	isForFacilitiesFloorPlan: false,
	displayChevrons: true
};

export default RecursiveTreeView;
